import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { Menu, X, Calendar, MapPin } from 'lucide-react';
import { SITE_DATA } from '../data/Constants';

const Header = () => {
  const [isNavOpen, setIsNavOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const handleNavClick = (path) => {
    navigate(path);
    setIsNavOpen(false);
  };

  const navItems = [
    { name: 'Home', path: '/' },
    { name: 'About', path: '/about' },
    { name: 'Products', path: '/products' },
    { name: 'Contact', path: '/contact' },
  ];

  return (
    <>
      <header className='fixed top-0 left-0 w-full z-50 px-6 py-4 flex justify-between items-center bg-white backdrop-blur-md border-b border-gray-100 shadow-sm transition-all duration-300'>
        <Link to="/" className='block'>
          <img
            src={SITE_DATA.brandLogo}
            alt={SITE_DATA.brandName}
            width={220}
            height={48}
            fetchpriority="high"
            className='h-10 md:h-12 w-auto object-contain'
          />
        </Link>

        <div className='flex items-center gap-4 lg:gap-8 pointer-events-auto'>
          <div className='hidden lg:flex flex-col items-end text-right mr-4 gap-1.5'>
            <a
              href={`tel:${SITE_DATA.phone}`}
              className='font-heading text-lg font-bold text-primary hover:text-secondary transition-colors leading-none'
            >
              {SITE_DATA.phone}
            </a>

            <a
              href={SITE_DATA.mapLink}
              target="_blank"
              rel="noopener noreferrer"
              className='flex items-center gap-1.5 text-xs text-gray-500 uppercase tracking-wider font-medium hover:text-primary transition-colors group leading-none pt-1'
            >
              <MapPin className='w-3.5 h-3.5 group-hover:animate-bounce' />
              <span className='group-hover:underline underline-offset-2'>{SITE_DATA.location}</span>
            </a>
          </div>

          <button
            onClick={() => navigate('/contact')}
            className="hidden md:flex items-center gap-2 px-6 py-3 bg-primary hover:bg-secondary text-white rounded-xl transition-all duration-300 shadow-lg group"
          >
            <Calendar className="w-4 h-4" />
            <span className="text-xs uppercase tracking-widest font-bold">Book Consultation</span>
          </button>

          <button
            onClick={() => setIsNavOpen(!isNavOpen)}
            aria-label={isNavOpen ? "Close menu" : "Open menu"}
            className='flex items-center justify-center w-10 h-10 hover:bg-gray-100 rounded-full transition-colors duration-300 text-secondary'
          >
            {isNavOpen ? <X className='w-6 h-6' /> : <Menu className='w-6 h-6' />}
          </button>
        </div>
      </header>

      <div className={`fixed inset-0 bg-white z-60 transition-transform duration-500 ease-[cubic-bezier(0.32,0.72,0,1)] flex flex-col ${isNavOpen ? 'translate-x-0' : 'translate-x-full'}`}>
        <div className='flex justify-between items-center px-6 py-4 border-b border-gray-300'>
          <img
            src={SITE_DATA.brandLogo}
            alt={SITE_DATA.brandName}
            width={220}
            height={48}
            fetchpriority="high"
            className='h-10 md:h-12 w-auto object-contain'
          />
          <button
            onClick={() => setIsNavOpen(false)}
            aria-label="Close menu"
            className='p-2 hover:bg-gray-100 rounded-full transition-colors text-secondary'
          >
            <X className='w-8 h-8' />
          </button>
        </div>

        <div className='flex flex-col items-center justify-center flex-1 gap-8 p-6'>
          {navItems.map((item) => {
            const isActive = location.pathname === item.path;

            return (
              <button
                key={item.name}
                onClick={() => handleNavClick(item.path)}
                className='group relative flex items-center gap-4'
              >
                <span
                  className={`font-heading text-4xl md:text-5xl uppercase font-bold transition-colors ${isActive ? 'text-primary' : 'text-secondary group-hover:text-primary'}`}
                >
                  {item.name}
                </span>
              </button>
            );
          })}
        </div>

        <div className='p-8 bg-white border-t border-gray-300 text-center gap-4 flex flex-col items-center justify-center'>
          <a href={`tel:${SITE_DATA.phone}`} className='block font-heading text-2xl text-primary hover:text-secondary font-bold p-2'>
            {SITE_DATA.phone}
          </a>
          <a
            href={SITE_DATA.mapLink}
            target="_blank"
            rel="noopener noreferrer"
            className='flex items-center justify-center gap-2 p-2 text-gray-500 hover:text-primary transition-colors text-sm uppercase tracking-widest font-bold'
          >
            <MapPin className='w-4 h-4' /> {SITE_DATA.location}
          </a>
        </div>
      </div>
    </>
  );
};

export default Header;